import React from 'react'
import Accordion from 'react-bootstrap/Accordion'
import Card from "react-bootstrap/Card";

const Directions_Accordion = ({title, content}) => {
    return (
        <Accordion defaultActiveKey="0">
            <Card className="accordion-card">
                <Accordion.Toggle as={Card.Header} eventKey="1">
                <span className="accordion-title unselectable">{title}</span>
                </Accordion.Toggle>
                <Accordion.Collapse eventKey="1">
                <Card.Body className="accordion-body">
                    {content}
                </Card.Body>
                </Accordion.Collapse>
            </Card>
        </Accordion>
    )
}

export default Directions_Accordion


